export const IssueRefundIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
    >
      <path
        d="M6.33203 9.16658C6.33203 9.81325 6.83204 10.3332 7.44538 10.3332H8.69869C9.23203 10.3332 9.66537 9.87992 9.66537 9.31325C9.66537 8.70658 9.39871 8.48658 9.00538 8.34658L6.9987 7.64658C6.60537 7.50658 6.3387 7.29325 6.3387 6.67991C6.3387 6.11991 6.77203 5.65991 7.30536 5.65991H8.5587C9.17203 5.65991 9.67204 6.17991 9.67204 6.82658"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 5V11"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6654 7.99993C14.6654 11.6799 11.6787 14.6666 7.99871 14.6666C4.3187 14.6666 1.33203 11.6799 1.33203 7.99993C1.33203 4.31992 4.3187 1.33325 7.99871 1.33325"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.332 2V4.66667H13.9987"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6654 1.33325L11.332 4.66659"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
